module.exports = __webpack_public_path__ + "static/8-d1852a9361a361aaa11cd96929ba81e7.gif";